import { rateScales } from './constants'

export const getAnnualTaxableIncome = (amount) => {
  return rateScales.find(
    (scale) => amount >= scale.annualTaxableIncome.from && amount <= scale.annualTaxableIncome.to,
  )
}

export const priceFields = [
  'ticketFees',
  'taxableIncomeRental',
  'taxableIncomeInvestments',
  'otherTaxableIncomes',
]

// Campos que requieren formato de precio
export const handlePriceChange = (inputName, e, setValue) => {
  if (priceFields.includes(inputName)) {
    let inputValue = e.target.value
    const numericValue = parseFloat(inputValue.replace(/[^\d]/g, ''))
    if (!isNaN(numericValue)) {
      let formattedValue = numericValue.toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      if (Number.isInteger(numericValue)) {
        formattedValue = numericValue.toLocaleString('es-AR')
      }
      setValue(inputName, numericValue)
      e.target.value = formattedValue
    }
  } else {
    setValue(inputName, e.target.value)
  }
}

// Función para manejar el evento onKeyDown y permitir solo valores numéricos
export const handleKeyPress = (inputName, e) => {
  const allowedCharacters = /[0-9.]/
  const isPriceField = priceFields.includes(inputName)
  if (isPriceField && !allowedCharacters.test(e.key) && e.key !== 'Backspace') {
    e.preventDefault()
  }
}
